module.exports = __webpack_public_path__ + "img/HEB ONLINE.77c777de.png";